// ----------------------------------------------------------------------------
// Component: Scrolling Product Content
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

import './_scrolling-product-content.scss';

// -------------------------------------
// Hooks
// -------------------------------------



function scrollingProduct () {
    var $window = $(window)
    var winHeight = $window.height() * 1
    var spcContentBlockItem = $('.scrolling-product-content__block-item')

    document.addEventListener('scroll', (e) => {
        var scrolled = $window.scrollTop()
    
        if ( spcContentBlockItem.length ) {
            spcContentBlockItem.each(function () {
                var $this = $(this),
                    offsetTop = $this.offset().top - 25;
        
                if (scrolled + winHeight > offsetTop && offsetTop - 25 > scrolled) {
                    $this.addClass('block-item--visible');
                }
            });
        }
    });
};

scrollingProduct();

